export default "__VITE_ASSET__CEjgn9TQ__"